import { z } from 'zod';
import { domainNameSchema } from './sites.js';

/**
 * A new site ordered in one go (ADR-0059): the template, the market, the
 * site's name and its domain — bought through the purchase whose check found
 * it free, or one already held (`purchase` null).
 */
export const createSiteOrderSchema = z
  .object({
    templateId: z.string().uuid(),
    market: z.string().min(2).max(10).regex(/^[a-z]{2}(?:-[a-z]{2})?$/),
    name: z.string().trim().min(1).max(160),
    domain: domainNameSchema,
    purchase: z
      .object({
        purchaseId: z.string().uuid(),
        itemId: z.string().regex(/^[A-Za-z0-9_-]{6,64}$/),
      })
      .strict()
      .nullable(),
  })
  .strict();
export type CreateSiteOrderInput = z.infer<typeof createSiteOrderSchema>;
export type CreateSiteOrderRequest = z.input<typeof createSiteOrderSchema>;
